module.exports = __webpack_public_path__ + "img/p12.02a77627.jpg";